/**
 * SolutionViewer - View component for 3D solution visualization
 * Pure presentation component with no business logic
 */

import React from 'react';

export default function SolutionViewer({ scramble, moves }) {
  const algorithm = moves.map(m => m.text).join(' ');

  return (
    <div style={styles.solutionViewer}>
      <h2>Solution Viewer</h2>
      <twisty-player
        experimental-setup-alg={scramble}
        alg={algorithm}
        background="none"
        style={styles.twistyPlayer}
      />
    </div>
  );
}

const styles = {
  solutionViewer: {
    marginTop: 20
  },
  twistyPlayer: {
    width: '100%',
    height: '400px',
    border: '1px solid #ccc',
    borderRadius: '8px'
  }
};
